import type { ProductListItemInternal } from 'types/capi/shared';

import ProductCard from '~/components/ProductCard';
import gtm from '~/services/gtm.client';

type ProductCardCarouselProps = {
  allowNotifications: boolean;
  id: string;
  onViewMoreProductsClick?: () => void;
  padImages: boolean;
  products: ProductListItemInternal[];
  title: string;
  viewMoreCopy?: string;
  viewMoreUrl?: string;
};

const ProductCardCarousel = ({
  id,
  products,
  title,
  viewMoreCopy,
  onViewMoreProductsClick,
  viewMoreUrl,
  padImages,
  allowNotifications
}: ProductCardCarouselProps) => {
  function sendGtmEvent() {
    gtm.sendUserInteractionEvent(`${title} click`, 'Body');
  }

  const hasViewMoreLink = Boolean(viewMoreUrl && viewMoreCopy);

  return (
    <div data-cy={id}>
      <div className="flex items-center justify-between pb-4">
        <h3 className="flex items-center justify-self-start text-lg font-bold md:col-span-2">
          {title}
        </h3>
        {hasViewMoreLink && (
          <a
            href={viewMoreUrl}
            className="flex items-center justify-self-end md:col-span-2"
            onClick={onViewMoreProductsClick}
          >
            <p className="cursor-pointer text-sm underline hover:text-gray-600">
              {viewMoreCopy}
            </p>
          </a>
        )}
      </div>
      <div className="mx-auto grid max-w-screen-2xl grid-cols-2 gap-3 md:grid-cols-4">
        {products.map((product, index) => (
          <ProductCard.Internal
            key={product.id}
            product={product}
            padImage={padImages}
            cardSize="small"
            allowNotifications={allowNotifications}
            onClick={sendGtmEvent}
            imageLoading={index < 10 ? 'eager' : 'lazy'}
            pageType="pdp"
            pagePosition="PDP Carousel"
          />
        ))}
      </div>
    </div>
  );
};

export default ProductCardCarousel;
